/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box } from '@mantine/core';

// Components
import { MintStatus } from '@components/atoms/MintStatus';

// Helpers
import { capitalizeString } from '@utils/functions';

// Styles
import styles from './CellConversionFactorStatus.module.css';
import { TParsedConversionFactor } from '@pages/ConversionFactor/types';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const CellConversionFactorStatus = (props: {
	row: TParsedConversionFactor;
}) => {
	/* ******************************** HELPERS ******************************* */
	const getConversionFactorStatusType = (
		status: string
	) => {
		switch (status) {
			case 'CURRENT':
				return 'success';
			case 'PASSED':
				return 'warning';
			default:
				return '';
		}
	};
	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={styles.cell}>
			<MintStatus
				type={getConversionFactorStatusType(
					props.row && props.row.active
						? props.row.active
						: ''
				)}
			>
				{capitalizeString(props.row && props.row.active)}
			</MintStatus>
		</Box>
	);
};
